import React from 'react';
import IncentiveCard from './IncentiveCard';
import { 
  PresentationChartLineIcon, 
  UserGroupIcon, 
  GlobeAltIcon,
  TicketIcon,
  VideoCameraIcon,
  AcademicCapIcon
} from '@heroicons/react/24/outline';

const SpeakerIncentives: React.FC = () => {
  const incentives = [
    {
      title: 'Global Visibility',
      description: 'Gain exposure to an international audience and establish yourself as a thought leader.',
      icon: <GlobeAltIcon className="w-8 h-8" />
    },
    {
      title: 'Network with Industry Leaders',
      description: 'Connect with decision-makers, researchers, and practitioners in language technology.',
      icon: <UserGroupIcon className="w-8 h-8" />
    },
    {
      title: 'Present at the Austrian Parliament',
      description: 'Share your insights at one of the most prestigious venues in Vienna.',
      icon: <PresentationChartLineIcon className="w-8 h-8" />
    },
    {
      title: 'Social Media Promotion',
      description: 'Get featured on our social media channels and conference website to boost your visibility.',
      icon: <VideoCameraIcon className="w-8 h-8" />
    },
    {
      title: 'Knowledge Exchange',
      description: 'Learn from other experts and stay updated with the latest developments in the field.',
      icon: <AcademicCapIcon className="w-8 h-8" />
    },
    {
      title: 'Discounted Conference Pass',
      description: 'Receive a significant discount on access to all conference sessions and networking events.',
      icon: <TicketIcon className="w-8 h-8" />
    }
  ];

  return (
    <div className="max-w-7xl mx-auto">
      <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
        Why Present at Language Intelligence 2025?
      </h2>
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {incentives.map((incentive, index) => (
          <IncentiveCard
            key={index}
            title={incentive.title}
            description={incentive.description}
            icon={incentive.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default SpeakerIncentives;
